import en from "@/locales/en";
import fr from "@/locales/fr";

const locales = {
    en: en,
    fr: fr
};

export default locales
